import React, { useEffect, useState } from "react";
import { Drawer, Form, Input, InputNumber, DatePicker, Icon, notification, Select } from "antd";
import axios from "axios";
import moment from "moment";

const { Option } = Select;
const { TextArea } = Input;
const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const DrawerAdicionarEstudo = ({ id, visible, atualizarListagem, onClose, form }) => {
    const [registo, setRegisto] = useState({
        id: null,
        data_realizacao: moment(),
        descricao: "",
        tecnicas_utilizadas: ""
    });
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = e => {
        e.preventDefault();
        form.validateFields((err, values) => {
            if (!err) {
                if (id) alterarEstudo(values);
                else adicionarEstudo(values);
            }
        });
    };

    const carregarDetalhe = id => {
        axios({
            method: "get",
            url: "/api/atendimento/carregar-plano-atendimento",
            params: {
                id
            }
        })
            .then(response => {
                const dados = {
                    ...response.data,
                    data_realizacao: response.data.data_realizacao ? moment(response.data.data_realizacao) : null
                };
                setRegisto(dados);
            })
            .catch(error => {
                openNotificationWithIcon(
                    "error",
                    "Erro",
                    error.response.data || "Ocorreu um erro ao carregar o detalhe do estudo de caso."
                );
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const adicionarEstudo = registo => {
        setIsLoading(true);

        var estudo = {
            disciplinaId: localStorage.getItem("codigo_curso"),
            tipo: "estudo_caso_diagnostico",
            dataRealizacao: registo.data_realizacao.format("YYYY-MM-DD"),
            descricao: registo.descricao,
            tecnicasUtilizadas: registo.tecnicas_utilizadas
        };

        axios({
            method: "post",
            url: "/api/atendimento/adicionar-plano-atendimento",
            data: estudo
        })
            .then(() => {
                openNotificationWithIcon("success", "Sucesso", "Estudo de caso criado com sucesso.");
                atualizarListagem();
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response.data || "Ocorreu um erro ao criar o estudo de caso.");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const alterarEstudo = registo => {
        setIsLoading(true);

        var estudo = {
            id: id,
            dataRealizacao: registo.data_realizacao.format("YYYY-MM-DD"),
            descricao: registo.descricao,
            tecnicasUtilizadas: registo.tecnicas_utilizadas
        };

        axios({
            method: "put",
            url: "/api/atendimento/alterar-plano-atendimento",
            data: estudo
        })
            .then(() => {
                openNotificationWithIcon("success", "Sucesso", "Estudo de caso altarado com sucesso.");
                atualizarListagem();
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response.data || "Ocorreu um erro ao alterar o estudo de caso.");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const handleClose = () => {
        onClose();
        limparCampos();
    };

    const afterVisibleChange = aberto => {
        if (!aberto && id === null) {
            limparCampos();
        }
    };

    const limparCampos = () => {
        form.resetFields();
        setRegisto({
            id: null,
            data_realizacao: moment(),
            descricao: "",
            tecnicas_utilizadas: ""
        });
    };

    useEffect(() => {
        if (visible && id) {
            carregarDetalhe(id);
        }
    }, [id, visible]);

    const { getFieldDecorator } = form;

    return (
        <>
            <Drawer
                title={
                    <div>
                        <div style={{ fontWeight: "bold", fontSize: 16 }}>Cadastro de estudo de caso</div>
                        <div style={{ fontSize: 12, color: "#888" }}>Preencha os dados para cadastrar um novo estudo de caso.</div>
                    </div>
                }
                className="drawer-adicionar-evento drawer-add-cursos"
                width={720}
                onClose={handleClose}
                visible={visible}
                style={{
                    overflow: "auto",
                    height: "calc(100% - 108px)",
                    paddingBottom: "108px"
                }}
                maskClosable={false}
                afterVisibleChange={afterVisibleChange}
            >
                <div className="bloco-info">
                    <Form className="form-categorias" layout="horizontal" onSubmit={handleSubmit}>
                        <div className="bloco" style={{ marginBottom: 50 }}>
                            <Form.Item label="Data de Realização">
                                {getFieldDecorator("data_realizacao", {
                                    initialValue: registo.data_realizacao,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Campo obrigatório"
                                        }
                                    ]
                                })(<DatePicker className="input-25" placeholder="Selecionar" format="DD-MM-YYYY" />)}
                            </Form.Item>
                        </div>
                        <div className="bloco" style={{ marginBottom: 50 }}>
                            <Form.Item label="Descrição">
                                {getFieldDecorator("descricao", {
                                    initialValue: registo.descricao,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Campo obrigatório"
                                        }
                                    ]
                                })(<TextArea rows={4} style={{ height: 100 }} />)}
                            </Form.Item>
                            <Form.Item label="Técnicas Utilizadas">
                                {getFieldDecorator("tecnicas_utilizadas", { initialValue: registo.tecnicas_utilizadas })(
                                    <TextArea rows={4} style={{ height: 100 }} />
                                )}
                            </Form.Item>
                        </div>
                        <div className="ant-drawer-footer">
                            <button
                                className="botao-secundario"
                                type="button"
                                onClick={handleClose}
                                style={{ marginRight: 20, display: "inline-block" }}
                            >
                                Cancelar
                            </button>
                            <button className="botao-principal" disabled={isLoading}>
                                {isLoading ? <Icon type="loading" /> : null}
                                Salvar estudo
                            </button>
                        </div>
                    </Form>
                </div>
            </Drawer>
        </>
    );
};

export default Form.create({ name: "form-drawer-adicionar-estudo" })(DrawerAdicionarEstudo);
